module.exports = __webpack_public_path__ + "img/stock9.42801040.png";